module.exports = __webpack_public_path__ + "media/images/university_logos/University-of-York-b27dda3a97d89dadf135766c3f59c569.svg";